<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container"
  >
    <div :style="style.row">
      <div :style="style.formContainer">
        <div :style="style.labelContainer">
          <TextFormLabelPrimary>
            Title
          </TextFormLabelPrimary>
        </div>
        <InputSecondary
          v-model="form.data.title"
          placeholder="Enter your title"
          @change-input="updateFormData"
          :style="style.input"
        />
      </div>
      <div :style="style.formContainer">
        <div :style="style.labelContainer">
          <TextFormLabelPrimary>
            Location
          </TextFormLabelPrimary>
        </div>
        <InputSecondary
          v-model="form.data.location"
          placeholder="Enter your location"
          @change-input="updateFormData"
          :style="style.input"
        />
      </div>
    </div>
    <div :style="style.row">
      <div :style="style.formContainer">
        <div :style="style.labelContainer">
          <TextFormLabelPrimary>
            Short bio
          </TextFormLabelPrimary>
        </div>
        <TextareaSecondary
          v-model="form.data.description"
          placeholder="Enter your short bio"
          @change-input="updateFormData"
        />
      </div>
    </div>
    <div :style="style.row">
      <div :style="style.formContainer">
        <div :style="style.labelContainer">
          <TextFormLabelPrimary>
            Links
          </TextFormLabelPrimary>
          <TextButtonSmallMuted
            :disabled="form.data.links.length >= tenantUserLinksLengthMax"
            @click="addTenantUserLinksForm"
          >
            Add
          </TextButtonSmallMuted>
        </div>
        <div v-if="form.data.links.length === 1">
          <InputSecondary
            v-model="form.data.links[0].url"
            :style="style.inputLink"
          />
        </div>
        <div
          v-else
          v-for="(link, index) in form.data.links"
          :key="index"
        >
          <InputSecondary
            v-model="form.data.links[index].url"
            :style="style.inputLink"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import InputSecondary from '@modules/v2/input/input-secondary'
  import TextareaSecondary from '@modules/v2/textarea/textarea-secondary'
  import TextButtonSmallMuted from '@modules/v2/button/text-button-small-muted'
  import TextFormLabelPrimary from '@modules/v2/text/text-form-label-primary'
  import { Layout } from '@js/styles'
  import { LENGTH_LIMITS } from '@js/constants'

  export default {
    name: 'FormTenantUserPrimary',
    inheritAttrs: false,
    components: {
      InputSecondary,
      TextareaSecondary,
      TextButtonSmallMuted,
      TextFormLabelPrimary,
    },
    props: {
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      form: {
        type: Object,
        required: false,
        default: null,
      },
      tenantUser: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        tenantUserLinksLengthMax: LENGTH_LIMITS.TENANT_USER_LINKS_LENGTH_MAX,
        style: {
          container: {
            display: 'flex',
            flexDirection: 'column',
            padding: '0 -12px',
            width: '100%',
          },
          formContainer: {
            flex: 1,
            margin: `${Layout.space.sm} 0`,
            minWidth: '200px',
            padding: '0 12px',
          },
          input: {
            width: '100%',
          },
          inputLink: {
            margin: `${Layout.space.sm} 0`,
            width: '100%',
          },
          labelContainer: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            margin: `0 0 ${Layout.space.xs} 0`,
            width: '100%',
          },
          row: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: '58px',
          },
        },
      };
    },
    methods: {
      addTenantUserLinksForm: function () {
        this.form.extendLinks();
      },
      updateFormData: function () {
        this.$emit('update:form', this.form);
      },
    },
    watch: {
      form: {
        handler: function (newVal, oldVal) {
          this.form = newVal;
        },
        deep: true,
      },
    },
  };
</script>
